/**
 * The registry, read for a person: the current version of each strategy and
 * its Risk policy in words. The policy is relative — it names a multiple of
 * the slot margin, never a sum — so the sentence stays true as the account grows.
 */
import { shifted, toPlaces } from "@/shared/money/money";

function text(value: unknown): string | null {
  return typeof value === "string" ? value : typeof value === "number" ? String(value) : null;
}

/** «позиция ≤ 2× маржи · запас 15 п.п. до ликвидации · данные ≤ 60 с». */
export function policyText(policy: { readonly [key: string]: unknown }): string {
  const multiple = text(policy.slot_exposure_multiple);
  const buffer = text(policy.liquidation_safety_buffer);
  const age = text(policy.maximum_market_data_age_seconds);
  if (multiple === null || buffer === null || age === null) return "не читаются";
  const points = toPlaces(shifted(buffer, 2), 0);
  return `позиция ≤ ${multiple}× маржи · запас ${points} п.п. до ликвидации · данные ≤ ${age} с`;
}
